<template>
  <router-view
    class="view"
    :cachedTheme="cachedTheme"
    @set-background-color="setBackgroundColor"
    @set-background-image="setBackgroundImage"
  />

  <AppVersion />
</template>

<script setup lang="ts">
import AppVersion from "@/components/AppVersion.vue";
import { theme } from "@entersekt/types/build/3-5-0/endpoint";
import { getStoredTheme, getCachedImages } from "@/store/index";
import { ref } from "vue";

let backgroundColor = ref("#ffffff");
let backgroundImage = ref("");
function setBackgroundColor(background: string) {
  backgroundColor.value = background;
}

function setBackgroundImage(background: string) {
  backgroundImage.value = `url(${background})`;
}

const cachedTheme = ref<theme>({});
const storedTheme = getStoredTheme();
if (storedTheme) {
  cachedTheme.value = storedTheme;
}

const storedImages = getCachedImages();
if (storedImages) {
  var images = [];
  for (let i = 0; i < storedImages.length; i++) {
    images[i] = new Image();
    images[i].src = storedImages[i];
  }
}

if (cachedTheme.value.pageBackgroundColor) {
  setBackgroundColor(cachedTheme.value.pageBackgroundColor);
}
</script>

<style>
.view {
  min-height: 100%; /* Fallback for browsers do NOT support vh unit */
  min-height: 100vh; /* These two lines are counted as one :-)       */

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  background-color: v-bind(backgroundColor);
  background-image: v-bind(backgroundImage);
  background-size: cover;
  background-repeat: no-repeat;
}

html,
body {
  margin: 0;
  height: fit-content;
  min-height: 100vh;
  min-height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

::-webkit-scrollbar {
  background: transparent; /* Chrome/Safari/Webkit */
  width: 0px;
}
</style>
